import { useEffect, useRef } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Build wss://.../api/ws/chat?token=...
function buildWsUrl(token) {
  const url = new URL(BACKEND_URL);
  const proto = url.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${url.host}/api/ws/chat?token=${encodeURIComponent(token)}`;
}

export function useChatSocket(onMessage) {
  const ref = useRef(null);
  const handlerRef = useRef(onMessage);
  useEffect(() => { handlerRef.current = onMessage; }, [onMessage]);

  useEffect(() => {
    const token = localStorage.getItem("ym_access_token");
    if (!token) return;
    let cancelled = false;
    let retryTimer = null;

    const connect = () => {
      if (cancelled) return;
      try {
        const ws = new WebSocket(buildWsUrl(token));
        ref.current = ws;
        ws.onmessage = (ev) => {
          try {
            const data = JSON.parse(ev.data);
            if (handlerRef.current) handlerRef.current(data);
          } catch { /* ignore */ }
        };
        ws.onclose = () => {
          if (cancelled) return;
          retryTimer = setTimeout(connect, 3000);
        };
        ws.onerror = () => {
          try { ws.close(); } catch { /* ignore */ }
        };
      } catch {
        retryTimer = setTimeout(connect, 3000);
      }
    };

    connect();
    return () => {
      cancelled = true;
      if (retryTimer) clearTimeout(retryTimer);
      if (ref.current) try { ref.current.close(); } catch { /* ignore */ }
    };
  }, []);

  return ref;
}
